import { InfoCheck } from '@teamsparta/stack-icons';
import { atom, useAtom } from 'jotai';
import React, { useEffect } from 'react';

import * as S from './WebinarToast.style';

export const webinarToastAtom = atom<string>('');

export default function WebinarToast() {
  const [toast, setToast] = useAtom(webinarToastAtom);
  useEffect(() => {
    if (toast !== '') {
      setTimeout(() => {
        setToast('');
      }, 1500);
    }
  }, [toast]);
  return (
    <S.ToastFrame>
      {toast && (
        <S.Toast show={true}>
          <InfoCheck size={24} color='#46BF3C' />
          {toast}
        </S.Toast>
      )}
    </S.ToastFrame>
  );
}
